import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=2a940624&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a940624')) {
      api.createRecord('2a940624', component.options)
    } else {
      api.reload('2a940624', component.options)
    }
    module.hot.accept("./TagList.vue?vue&type=template&id=2a940624&", function () {
      api.rerender('2a940624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/TagList.vue"
export default component.exports